export interface IOptions {
  id: string;
  name: string;
  isChecked?: boolean;
}

/**
 *
 */
export function gendersFilter(): Array<IOptions> {
  return [
    { id: 'male', name: 'Male' },
    { id: 'female', name: 'Female' },
    { id: '', name: 'No preference' },
  ];
}

/**
 *
 */
export function frequenciesFilter(): Array<IOptions> {
  return [
    { id: 'ongoing', name: 'Ongoing, after trial period' },
    { id: 'once_off', name: 'Once off' },
  ];
}

/**
 *
 */
export function schedulingFilter(): Array<IOptions> {
  return [
    { id: 'flexible', name: 'I’m flexible' },
    { id: 'specific', name: 'I have preferred days and times' },
  ];
}

/**
 *
 */
export function participantsAgesFilter(): Array<IOptions> {
  return [
    { id: 'baby', name: '<5' },
    { id: 'grade_schooler', name: '5-12' },
    { id: 'teen', name: '13-18' },
    { id: 'young_adult', name: '19-25' },
    { id: 'middle_aged_adult', name: '26-45' },
    { id: 'old_adult', name: '46-65' },
    { id: 'aged', name: '65+' },
  ];
}

/**
 *
 */
export function hoursFilters(): Array<IOptions> {
  return [
    { id: 'low', name: 'Less than 5' },
    { id: 'med', name: '5 to 10' },
    { id: 'high', name: '10 to 20' },
    { id: 'full_time', name: 'More than 20' },
  ];
}

/**
 *
 */
export function states() {
  return {
    'Australian Capital Territory': 'ACT',
    ACT: 'Australian Capital Territory',
    'New South Wales': 'NSW',
    NSW: 'New South Wales',
    'Northern Territory': 'NT',
    NT: 'Northern Territory',
    Queensland: 'QLD',
    QLD: 'Queensland',
    'South Australia': 'SA',
    SA: 'South Australia',
    Tasmania: 'TAS',
    TAS: 'Tasmania',
    Victoria: 'VIC',
    VIC: 'Victoria',
    'Western Australia': 'WA',
    WA: 'Western Australia',
  };
}

/**
 *
 */
export function daysFilter(): Array<IOptions> {
  return [
    { id: 'Monday', name: 'Monday' },
    { id: 'Tuesday', name: 'Tuesday' },
    { id: 'Wednesday', name: 'Wednesday' },
    { id: 'Thursday', name: 'Thursday' },
    { id: 'Friday', name: 'Friday' },
    { id: 'Friday', name: 'Saturday' },
    { id: 'Sunday', name: 'Sunday' },
  ];
}

/**
 *
 */
export function orderFilter(): Array<IOptions> {
  return [
    { id: 'age', name: 'Most recent' },
    { id: 'distance', name: 'Closest' },
  ];
}

/**
 *
 */
export function specificScheduleDays() {
  const days = [
    {
      name: 'Monday',
      value: [
        { name: 'Morning', value: 'required_monday_morning' },
        { name: 'Afternoon', value: 'required_monday_afternoon' },
        { name: 'Evening', value: 'required_monday_evening' },
      ],
    },
    {
      name: 'Tuesday',
      value: [
        { name: 'Morning', value: 'required_tuesday_morning' },
        { name: 'Afternoon', value: 'required_tuesday_afternoon' },
        { name: 'Evening', value: 'required_tuesday_evening' },
      ],
    },
    {
      name: 'Wednesday',
      value: [
        { name: 'Morning', value: 'required_wednesday_morning' },
        { name: 'Afternoon', value: 'required_wednesday_afternoon' },
        { name: 'Evening', value: 'required_wednesday_evening' },
      ],
    },
    {
      name: 'Thursday',
      value: [
        { name: 'Morning', value: 'required_thursday_morning' },
        { name: 'Afternoon', value: 'required_thursday_afternoon' },
        { name: 'Evening', value: 'required_thursday_evening' },
      ],
    },
    {
      name: 'Friday',
      value: [
        { name: 'Morning', value: 'required_friday_morning' },
        { name: 'Afternoon', value: 'required_friday_afternoon' },
        { name: 'Evening', value: 'required_friday_evening' },
      ],
    },
    {
      name: 'Saturday',
      value: [
        { name: 'Morning', value: 'required_saturday_morning' },
        { name: 'Afternoon', value: 'required_saturday_afternoon' },
        { name: 'Evening', value: 'required_saturday_evening' },
      ],
    },
    {
      name: 'Sunday',
      value: [
        { name: 'Morning', value: 'required_sunday_morning' },
        { name: 'Afternoon', value: 'required_sunday_afternoon' },
        { name: 'Evening', value: 'required_sunday_evening' },
      ],
    },
  ];
  return days;
}
